export const visit = (vm, at) => {
at({ "en": { "upgradePointTooltip": { "upgradePageLink_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, createElement( options, "Link", props, "Upgrade" ), " to perform this action." ); } } } });
};